import { render } from "./FooterAction.vue?vue&type=template&id=4c0fa904"
import script from "./FooterAction.vue?vue&type=script&lang=js"
export * from "./FooterAction.vue?vue&type=script&lang=js"
script.render = render

export default script